import React, { useEffect, useState } from "react";
import "../../assets/styles/rolesandpermissions.css";
import { IoBagAdd } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import { useViewRoles } from "../../hooks/role/role.show";
import RoleModal from "../../components/modal/role.modal";

const RolesAndpermissions = () => {

  const [roles, setRoles] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [isTagDropdownOpen, setIsTagDropdownOpen] = useState(false);
  const [tags, setTags] = useState([]);

  const { data: rolesData } = useViewRoles();

  useEffect(() => {
    if (rolesData?.data) {
      const formattedRoles = rolesData.data.map(role => ({
        id: role._id,
        name: role.name,
        permissions: role.permissions.map(perm => ({
          id: perm._id,
          name: perm.name,
          allowed: true
        }))
      }));
      setRoles(formattedRoles);
      
      if (formattedRoles.length > 0 && !activeTab) {
        setActiveTab(formattedRoles[0].name);
      }
    }
  }, [rolesData]);


  const handleTabClick = (roleName) => {
    setActiveTab(roleName);
  };

  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [editingTagId, setEditingTagId] = useState(null);
  const [editingTagName, setEditingTagName] = useState("");
  const [modalTags, setModalTags] = useState([]);
  const [editingRoleId, setEditingRoleId] = useState(null);
  const [editingRoleData, setEditingRoleData] = useState(null);

  const handleOpenRoleModal = () => {
    setEditingRoleId(null);
    setEditingRoleData(null);
    setFormData({ role: "" });
    setTags([]);
    setIsRoleModalOpen(true);
  };

  const handleCloseRoleModal = () => {
    setIsRoleModalOpen(false);
    setFormData({ role: "" });
    setTags([]);
    setEditingRoleId(null);
    setEditingRoleData(null);
  };

  const handleOpenEditRoleModal = () => {
    const currentRole = roles.find(role => role.name === activeTab);
    
    if (currentRole) {
      const originalRole = rolesData?.data?.find(r => r._id === currentRole.id);
      
      if (originalRole) {
        setEditingRoleId(currentRole.id);
        setEditingRoleData({
          name: originalRole.name,
          permissions: originalRole.permissions.map(p => p.name)
        });
        setIsRoleModalOpen(true);
      }
    }
  };


  const [formData, setFormData] = useState({
    role: "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    name: "",
    role: "",
  });


  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditFormData({
      name: "",
      role: "",
    });
  };



  return (
    <>
      <div className="permission-modal">
        <button className="commonButton" style={{marginLeft:"auto"}} onClick={handleOpenRoleModal}>
          <IoBagAdd size={20} color="#ffffff" style={{ marginRight: 8 }} />
          Add Roles
        </button>

        {/* Role Modal */}
        <RoleModal 
          isRoleModalOpen={isRoleModalOpen}
          handleCloseRoleModal={handleCloseRoleModal}
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
          tags={tags}
          setTags={setTags}
          editingRoleId={editingRoleId}
          editingRoleData={editingRoleData}
        />

        <div className="roles-permissions-container">
          <div className="tabs-header">
            {roles.map((role) => (
              <button
                key={role.id}
                className={`tab-button ${
                  activeTab === role.name ? "active" : ""
                }`}
                onClick={() => handleTabClick(role.name)}
              >
                {role.name}
              </button>
            ))}
          </div>

          <div className="tab-content">
            {roles
              .filter((role) => role.name === activeTab)
              .map((role) => (
                <div key={role.id} className="role-panel">
                  <h2>{role.name} Permissions</h2>
                  <div className="permissions-list">
                    {role.permissions
                      .filter((permission) => permission.allowed)
                      .map((permission, index) => (
                        <div key={index} className="permission-item">
                          <label className="permission-label">
                            <input
                              type="checkbox"
                              checked={permission.allowed}
                              disabled
                            />
                            <span className="permission-name">
                              {permission.name}
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            <hr
              style={{
                marginTop: "40px",
                background: "#cbcbcb67",
                height: "1px",
                border: "none",
              }}
            />
            <div className="permissions-header">
              <button
                onClick={handleOpenEditRoleModal}
               className="cancelBtn"
              >
                <FiEdit size={20} color="#ffffff" style={{ marginRight: 8 }} />
                Edit All
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RolesAndpermissions;
